
import React from 'react'
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import {Card} from 'react-bootstrap'


// const data = [
//   { name: 'Group A', value: 400 },
//   { name: 'Group B', value: 300 },
//   { name: 'Group C', value: 300 },
//   { name: 'Group D', value: 200 },
// ];

// const COLORS = ["#ef8a62", "#67a9cf", '#FFBB28', '#FF8042'];

// const RADIAN = Math.PI / 180;
// const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
//   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//   const x = cx + radius * Math.cos(-midAngle * RADIAN);
//   const y = cy + radius * Math.sin(-midAngle * RADIAN);

//   return (
//     <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
//       {`${(percent * 100).toFixed(0)}%`}
//     </text>
//   );
// };





export const MyPiePlot = ({port_data, fuelTypes, fuelTypeInfo, onClick}) => {

      const data = (pd,ft) =>
      {
        return(
          ft.map(f=> {return {name:fuelTypeInfo[f.name].short_display_name, value:pd[f.name]}})
        )
      }


      const PortNameToolTip = ({portname}) => {
        return <Card><Card.Body>{portname}</Card.Body></Card>
      }

      return (
          <PieChart width={100} height={100} onClick={()=>onClick(port_data.locode)}>
            <Pie
              data={data(port_data,fuelTypes)}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={false}
              isAnimationActive={false}
              outerRadius={50*Math.sqrt(port_data.fraction)}
              fill="#8884d8"
              dataKey="value"
              
            >
              {fuelTypes.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={fuelTypeInfo[entry.name].color_name} />
              ))}
            </Pie>
              <Tooltip content={<PortNameToolTip portname={port_data.name}/>} />
          </PieChart>

      );
  }